export default function StatsSection() {
  const stats = [
    { value: '50+', label: '精选软件' },
    { value: '1000+', label: '教程文章' },
    { value: '50万+', label: '月活用户' },
    { value: '99.7%', label: '播放成功率' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50 border-y border-background-200/70">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}